import { Nominal } from "@goodfill/nominal";

export type IssuerId = Nominal<"IssuerId">;
export const asIssuerId = (id: string) => id as unknown as IssuerId;

/**
 * Ticker alone is not unique, one ticker can be assigned to many
 * companies from some bigger group.
 */
export function createIssuerId(ticker: string, name: string): IssuerId {
  return asIssuerId(`${ticker}-${name}`);
}
